import React from "react";

const Footer = () => {

  const y = new Date().getFullYear();
  return <footer>Copyright {y}, All Rights Reserved.</footer>;
};

export default Footer;
